import { api } from "../lib";

export interface FlagDefinition {
  id: string;
  name: string;
  color: string;
  isActive: boolean;
  createdById: string | null;
  createdBy: { id: string; firstName: string; lastName: string } | null;
  createdAt: string;
  updatedAt: string;
}

export interface FlagDefinitionSummary {
  id: string;
  name: string;
  color: string;
}

export interface CaseFlagApplication {
  id: string;
  caseId: string;
  flagDefinitionId: string;
  flagDefinition: FlagDefinitionSummary & { isActive?: boolean };
  appliedById: string | null;
  appliedBy: { id: string; firstName: string; lastName: string } | null;
  createdAt: string;
}

export interface CreateFlagDefinitionInput {
  name: string;
  color: string;
}

export interface UpdateFlagDefinitionInput {
  name?: string;
  color?: string;
}

export const flagDefinitionsService = {
  // Flag definition CRUD
  getAll: async (isActive?: boolean) => {
    const params = isActive !== undefined ? `?isActive=${isActive}` : "";
    const res = await api.get<{ data: FlagDefinition[] }>(
      `/flag-definitions${params}`
    );
    return res.data;
  },

  getActive: async () => {
    const res = await api.get<{ data: FlagDefinitionSummary[] }>(
      "/flag-definitions/active"
    );
    return res.data;
  },

  create: async (input: CreateFlagDefinitionInput) => {
    const res = await api.post<{ data: FlagDefinition }>(
      "/flag-definitions",
      input
    );
    return res.data;
  },

  update: async (id: string, input: UpdateFlagDefinitionInput) => {
    const res = await api.put<{ data: FlagDefinition }>(
      `/flag-definitions/${id}`,
      input
    );
    return res.data;
  },

  delete: async (id: string) => {
    await api.delete<void>(`/flag-definitions/${id}`);
  },

  deactivate: async (id: string) => {
    const res = await api.patch<{ data: FlagDefinition }>(
      `/flag-definitions/${id}/deactivate`
    );
    return res.data;
  },

  reactivate: async (id: string) => {
    const res = await api.patch<{ data: FlagDefinition }>(
      `/flag-definitions/${id}/reactivate`
    );
    return res.data;
  },

  // Case flag operations
  getCaseFlags: async (caseId: string) => {
    const res = await api.get<{ data: CaseFlagApplication[] }>(
      `/cases/${caseId}/flags`
    );
    return res.data;
  },

  applyFlag: async (caseId: string, flagDefinitionId: string) => {
    const res = await api.post<{ data: CaseFlagApplication }>(
      `/cases/${caseId}/flags`,
      { flagDefinitionId }
    );
    return res.data;
  },

  removeFlag: async (caseId: string, applicationId: string) => {
    await api.delete<void>(`/cases/${caseId}/flags/${applicationId}`);
  },
};
